module.exports = __webpack_public_path__ + "static/media/05_gazetaesporte_mobile.1ffb3c99.jpg";